import React, { forwardRef, useEffect, useState } from "react"
import intl from "react-intl-universal"
import { Flex, toast } from "@stardust-ds/react"
import { useForm, Controller } from "react-hook-form"
import { NumericFormat } from "react-number-format"
import { CONTROL_LEVELS } from "../../../../constants"
import styles from "./index.module.scss"
import ArrowLeftIcon from "../../../../../../../assets/icons/ArrowLeftIcon"
import ArrowRightIcon from "../../../../../../../assets/icons/ArrowRightIcon"
import { EditIcon } from "../../../../../../../assets/icons/Edit"
import CommunicationIcon from "../../../../../../../assets/icons/CommunicationIcon"
import CloseIcon from "../../../../../../../assets/icons/CloseIcon"
import { ReactComponent as CheckCircleBrokenIcon } from "../../../../../../../assets/icons/iconCheck.svg"
import { TableFormLaunchContextProvider, useTableFormLaunch } from "./context"
import ModalComponent from "../../../../components/ModalComponent"
import RcmpTextArea from "../../../../../../atoms/TextArea"
import Button from "../../../../../../atoms/Button"
import { Drawer } from "../../../Releases/components/Drawer"
import { ModalInformation } from "../../../../components/ModalInformation"
import { updateLaunch, verifyLaunchHasManualAverage, updateLaunchObservation } from "../../../../../../../services/ciq"
import { fnisOnlyPermition, fnIsAccessPermition } from "../../../../../../../utils/verifyPermitions"
import TrashIcon from "../../../../../../../assets/icons/TrashIcon"
import ModalDeleteRun from "../modalDeleteRun"
import FileIcon from "../../../../../../../assets/icons/FileIcon"
import ModalObservation from "../../../Releases/components/ModalObservation"
import useDataApi from "../../../../../../../hooks/useDataApi"

const TableFormLaunchContext = (props) => {
  if (!props?.oAnalyte) return null

  return (
    <TableFormLaunchContextProvider>
      <TableFormLaunchs {...props} />
    </TableFormLaunchContextProvider>
  )
}
export default TableFormLaunchContext

const TableFormLaunchs = ({ oAnalyte, oDataRuns, fetchRuns, fetchRunsAndHistory }) => {
  const {
    bUpdateJustityModalIsOpen,
    setBUpdateJustityModalIsOpen,
    oLaunchs,
    setOAnalyte,
    oRunDetails,
    setORunDetails,
    disableEditMode,
    setOLastRun,
    oLaunchObservation,
    setOLaunchObservation
  } = useTableFormLaunch()

  useEffect(() => {
    setOAnalyte(oAnalyte)
  }, [oAnalyte])

  const { handleSubmit, register, reset } = useForm()
  const [oUpdateLaunchObservationRes, fnUpdateLaunchObservationReq] = useDataApi(updateLaunchObservation)
  const [oLaunchesHasManualAverage, fnLaunchesHasManualAverageReq, fnResetLaunchHasManualAverageReq] = useDataApi(verifyLaunchHasManualAverage)
  const [isloading, setIsLoading] = useState(false)
  const [oldValuesLevel, setOldValuesLevel] = useState([])
  const [bLaunchUpdateManualAverageModalIsOpen, setBLaunchUpdateManualAverageModalIsOpen] = useState(false)

  const aRuns = oDataRuns?.data
  const leftTableRuns = aRuns?.slice(0, 5)
  const rightTableRuns = aRuns?.slice(5, 10)

  setOLastRun(oDataRuns?.current_page <= 1 ? aRuns?.[0] || null : null)
  
  useEffect(() => {
    const { loading, done, data, error } = oUpdateLaunchObservationRes
    if (loading || !done) return

    if (data) {
      toast({
        type: "success",
        title: intl.get("ciq.launch_observation.launch_title"),
        description: intl.get("ciq.launch_observation.success.update"),
      })
      handleCloseModalObservation()
      fetchRuns(oDataRuns?.current_page)

      return
    }

    if (error) {
      toast({
        type: "error",
        title: intl.get("ciq.launch_observation.launch_title"),
        description: intl.get("ciq.launch_observation.errors.update"),
      })

      return
    }
  }, [oUpdateLaunchObservationRes])

  const onCloseModal = () => {
    setBUpdateJustityModalIsOpen(false)
    reset()
  }

  const onSave = async (data) => {
    if (data.justity.trim() === "") {
      return
    }

    const nvalueLevelOne = oLaunchs?.level1
      ? `${oLaunchs?.level1}`.replace(",", ".")
      : "0"
    const nvalueLevelTwo = oLaunchs?.level2
      ? `${oLaunchs?.level2}`.replace(",", ".")
      : "0"
    const nvalueLevelThree = oLaunchs?.level3
      ? `${oLaunchs?.level3}`.replace(",", ".")
      : "0"


    const dtLevelOne = {
      eqpanltrun_number: oLaunchs?.run.eqpanltrun_number,
      eqpanltlaunch_nvalue: oLaunchs.result_option_level1 ? null : Number(nvalueLevelOne),
      eqpanltlaunch_resultopt_nid: oLaunchs.result_option_level1
        ? oLaunchs.result_option_level1
        : null,
      eqpanltlaunch_change_reason: data.justity.trim(),
      eqpanltlaunch_elevel: 1,
    }

    const dtLevelTwo = {
      eqpanltrun_number: oLaunchs?.run.eqpanltrun_number,
      eqpanltlaunch_nvalue: oLaunchs.result_option_level2 ? null : Number(nvalueLevelTwo),
      eqpanltlaunch_resultopt_nid: oLaunchs.result_option_level2
        ? oLaunchs.result_option_level2
        : null,
      eqpanltlaunch_change_reason: data.justity.trim(),
      eqpanltlaunch_elevel: 2,
    }
    const dtLevelThree = {
      eqpanltrun_number: oLaunchs?.run.eqpanltrun_number,
      eqpanltlaunch_nvalue: oLaunchs.result_option_level3
        ? null
        : Number(nvalueLevelThree),
      eqpanltlaunch_resultopt_nid: oLaunchs.result_option_level3
        ? oLaunchs.result_option_level3
        : null,
      eqpanltlaunch_change_reason: data.justity.trim(),
      eqpanltlaunch_elevel: 3,
    }

    const arrayDefault = [
      oLaunchs?.level1 || oLaunchs?.result_option_level1 ? dtLevelOne : null,
      oLaunchs?.level2 || oLaunchs?.result_option_level2 ? dtLevelTwo : null,
      oLaunchs?.level3 || oLaunchs?.result_option_level3 ? dtLevelThree : null,
    ].filter((it) => it !== null)

    const bIdQuantitative = oAnalyte?.anlt_type === "Quantitativo"

    const filter = arrayDefault.filter((padrao) => {
      const matchingItem = oldValuesLevel.find(
        (segundo) => segundo?.eqpanltlaunch_elevel === padrao?.eqpanltlaunch_elevel,
      )
      return (
        (bIdQuantitative && matchingItem?.eqpanltlaunch_nvalue != padrao?.eqpanltlaunch_nvalue) ||
        (!bIdQuantitative && matchingItem?.eqpanltlaunch_resultopt_nid != padrao?.eqpanltlaunch_resultopt_nid)
      )
    })

    const dtSend = {
      launches: filter,
    }

    const nid = oLaunchs?.run.eqpanltrun_nid

    let hasManualAverage = false
    try {
      setIsLoading(true)
      const aLaunchesNIds = (oLaunchs?.run?.eqpanltrun_launches || [])?.map((launch) => {
        for (const l of filter || []) {
          if (l?.eqpanltlaunch_elevel === launch?.eqpanltlaunch_elevel) {
            return launch?.eqpanltlaunch_nid
          }
        }
      })?.filter((it) => it)

      if (aLaunchesNIds?.length > 0 && !oLaunchesHasManualAverage?.data?.data?.hasManualAverage) {
        const responseHasManualAverage = await fnLaunchesHasManualAverageReq(aLaunchesNIds?.join(","))
        if (responseHasManualAverage?.data?.hasManualAverage) {
          hasManualAverage = true
          setBLaunchUpdateManualAverageModalIsOpen(true)
          return
        }
      }

      await updateLaunch(dtSend, nid)
      fnResetLaunchHasManualAverageReq()
      fetchRunsAndHistory(oDataRuns?.current_page)
    } catch (err) {
      toast({
        type: "error",
        title: intl.get("ciq.release_details.error_update_launch.title"),
        description: intl.get("ciq.release_details.error_update_launch.description"),
      })
      reset()
      onCloseModal()
      disableEditMode()
    } finally {
      setIsLoading(false)

      if (!hasManualAverage) {
        reset()
        onCloseModal()
        disableEditMode()
      }
    }
  }

  const onCloseRunDetailsModal = () => {
    setORunDetails(null)
  }

  const onUpdateRun = async () => {
    await fetchRunsAndHistory(oDataRuns?.current_page)
  }

  const handleOnChangePage = async (nPage) => {
    await fetchRuns(nPage)
  }

  const handleUpdateLaunchObservation = async (oLaunch) => {
    if (!oLaunch?.eqpanltlaunch_nid) return

    await fnUpdateLaunchObservationReq(oLaunch.eqpanltlaunch_nid, oLaunch.cobservation)
  }

  const handleCloseModalObservation = () => {
    setOLaunchObservation(null)
  } 

  const handleConfirmOverwriteManualAverage = async () => {
    await handleSubmit(onSave)()
  }

  const handleCloseModalLaunchUpdateManualAverage = () => {
    setBLaunchUpdateManualAverageModalIsOpen(false)
    fnResetLaunchHasManualAverageReq()
    reset()
    onCloseModal()
    disableEditMode()
  }

  return (
    <Flex width="100%" flexDirection="column" gap="16px">
      <Paginate oPaginate={oDataRuns} onChangePage={handleOnChangePage} />
      <Flex
        width="100%"
        alignItems="flex-start"
        justifyContent="space-between"
        gap="16px"
        className={styles.launchsContainer}
      >
        {leftTableRuns && rightTableRuns && (
          <>
            <LaunchTable runs={leftTableRuns} setOldValuesLevel={setOldValuesLevel} />
            <LaunchTable runs={rightTableRuns} setOldValuesLevel={setOldValuesLevel} />
          </>
        )}
      </Flex>
      {bUpdateJustityModalIsOpen && (
        <ModalComponent
          title={intl.get("ciq.release_details.update_launch_modal.title")}
          fnCloseModal={onCloseModal}
          size="sm"
        >
          <form onSubmit={handleSubmit(onSave)}>
            <Flex
              width="100%"
              flexDirection="column"
              gap="17px"
              style={{ marginBottom: -32 }}
            >
              <RcmpTextArea
                {...register("justity")}
                label={intl.get(
                  "ciq.release_details.update_launch_modal.fields.justify.label",
                )}
                placeholder={intl.get(
                  "ciq.release_details.update_launch_modal.fields.justify.placeholder",
                )}
                maxHeight={114}
              />
              <Button type="submit" isLoading={isloading}>
                {intl.get("save_cap")}
              </Button>
            </Flex>
          </form>
        </ModalComponent>
      )}

      {!!oRunDetails && (
        <Drawer
          isOpen={!!oRunDetails}
          setIsOpen={onCloseRunDetailsModal}
          eqpanltrun_nid={oRunDetails?.eqpanltrun_nid}
          runNumber={oRunDetails?.eqpanltrun_number}
          analyteName={oAnalyte?.anlt_cname}
          typeAnalyte={oAnalyte?.anlt_type}
          onSuccessUpdateRun={onUpdateRun}
        />
      )}

      <ModalDeleteRun fetchRuns={fetchRunsAndHistory} />
      {!!oLaunchObservation && (
        <ModalObservation
          bIsOpen={!!oLaunchObservation}
          oLaunch={oLaunchObservation}
          onSubmit={handleUpdateLaunchObservation}
          onClose={handleCloseModalObservation}
          bIsLoading={oUpdateLaunchObservationRes.loading}
        />
      )}

      {bLaunchUpdateManualAverageModalIsOpen && (
        <ModalInformation
          title={intl.get(
            "ciq.release_details.modal_confirm_update_launch.title",
          )}
          description={intl.get(
            "ciq.release_details.modal_confirm_update_launch.description",
          )}
          onCancel={handleCloseModalLaunchUpdateManualAverage}
          type="submit"
          onSubmit={handleConfirmOverwriteManualAverage}
          isLoad={isloading}
        />
      )}
    </Flex>
  )
}

const oPaginateIconsProps = {
  width: 22,
  height: 22,
  fill: "#3B454F",
}

function fnHandleShowPages(currentPage, lastPage) {
  const MAX_PAGES = 5
  let showPages = []

  for (let i = currentPage - 2; i <= currentPage + 2; i++) {
    if (i > 0 && i <= lastPage) {
      showPages.push(i)
    }
  }

  while (showPages.length < MAX_PAGES && showPages.length < lastPage) {
    if (showPages[0] > 1) {
      showPages.unshift(showPages[0] - 1)
    }
    if (showPages[showPages.length - 1] < lastPage) {
      showPages.push(showPages[showPages.length - 1] + 1)
    }
  }

  return showPages
}

const Paginate = ({ oPaginate, onChangePage }) => {
  if (!oPaginate) return null

  const { current_page, last_page } = oPaginate

  const bDisabledPreviusPage = current_page <= 1
  const bDisabledNextPage = current_page >= last_page

  const aPages = fnHandleShowPages(current_page, last_page)

  const handleOnChangePage = async (nPage) => {
    if (nPage === current_page) return
    await onChangePage(nPage)
  }

  const handlePreviusPage = async () => {
    if (bDisabledPreviusPage) return
    await handleOnChangePage(current_page - 1)
  }

  const handleNextPage = async () => {
    if (bDisabledNextPage) return
    await handleOnChangePage(current_page + 1)
  }

  return (
    <div className={styles.paginateContainer}>
      <div
        onClick={handlePreviusPage}
        className={`${bDisabledPreviusPage ? styles.disabledPage : ""}`}
      >
        <ArrowLeftIcon {...oPaginateIconsProps} />
      </div>
      {aPages.map((page) => (
        <div
          className={`${styles.page} ${page === current_page ? styles.active : ""}`}
          key={`launch-page-${page}`}
          onClick={() => handleOnChangePage(page)}
        >
          {page}
        </div>
      ))}
      <div
        onClick={handleNextPage}
        className={`${bDisabledNextPage ? styles.disabledPage : ""}`}
      >
        <ArrowRightIcon {...oPaginateIconsProps} />
      </div>
    </div>
  )
}

const LaunchTable = ({ runs, setOldValuesLevel }) => {
  const [nDecimalPlaces, setNDecimalPlaces] = useState(0)

  if (!runs?.length) return <Flex width="100%" className={styles.tableContainer} />

  const { oAnalyte } = useTableFormLaunch()
  const analyteLevels = oAnalyte?.anlt_levels

  useEffect(() => {
    if (!oAnalyte) return

    setNDecimalPlaces(oAnalyte?.anlt_decimal_places)
  }, [oAnalyte?.anlt_nid])

  return (
    <Flex width="100%" className={styles.tableContainer}>
      <table>
        <thead>
          <tr>
            <th>Nº</th>
            {CONTROL_LEVELS.map((level) => {
              const analyteLevel = analyteLevels?.find(
                (analyteLevel) => analyteLevel.elevel === level.level,
              )
              return (
                <th
                  key={level.level}
                  style={analyteLevel?.bavailable ? { color: level.color } : {}}
                >
                  {intl.get(level.label)}
                </th>
              )
            })}
            <th />
          </tr>
        </thead>
        <tbody>
          {runs?.map((run) => (
            <TableRow
              key={run.run}
              run={run}
              nDecimalPlaces={nDecimalPlaces}
              setOldValuesLevel={setOldValuesLevel}
            />
          ))}
        </tbody>
      </table>
    </Flex>
  )
}

const TableRow = ({ run, nDecimalPlaces, setOldValuesLevel }) => {
  const [bIsEditing, setBIsEditing] = useState(false)

  const { oAnalyte, setORunDetails, setDisableEditMode, setORunDelete, oLastRun, setOLaunchObservation } = useTableFormLaunch()

  const bIsQuantitativeAnalaite = oAnalyte?.anlt_type === "Quantitativo"

  const enableEditing = (oldValue) => {
    setBIsEditing(true)
    setDisableEditMode(() => disableEditing)
    setOldValuesLevel(oldValue)
  }

  const disableEditing = () => {
    setBIsEditing(false)
  }

  if (bIsEditing)
    return (
      <TableRowEditMode
        run={run}
        onDisabledEditMode={disableEditing}
        nDecimalPlaces={nDecimalPlaces}
      />
    )

  const openRunDetails = () => {
    setORunDetails(run)
  }

  const handleOpenModalObservation = (oLaunch) => {
    const oFormatedLaunch = {
      ...oLaunch,
      cobservation: oLaunch?.eqpanltlaunch_cobservation,
    }
    setOLaunchObservation(oFormatedLaunch)
  }


  const bApproved = run?.eqpanltrun_status?.toLowerCase()?.startsWith("approved")
  const cCommunicationIconColor = bApproved ? "#1ECB4F" : "#00344A"
  const isOnlyAccessModuleCiq = fnisOnlyPermition("access-ciq")

  const isAccessCreateEditLaunchn = fnIsAccessPermition("create-edit-launch")
  const isOnlyView = !isAccessCreateEditLaunchn
  const isPermition = fnisOnlyPermition("access-ciq") || isOnlyView
  const bCanDeleteRun = !isPermition && oLastRun?.eqpanltrun_nid === run?.eqpanltrun_nid

  const openRunDeleteModal = () => {
    if (!bCanDeleteRun) return
  
    setORunDelete(run)
  }

  return (
    <tr>
      <td>{run?.eqpanltrun_number}</td>
      {CONTROL_LEVELS.map((level) => {
        const levelLaunch = run?.eqpanltrun_launches.find(
          (launch) => launch.eqpanltlaunch_elevel === level.level,
        )
        const cOptionsClass =
          levelLaunch?.eqpanltlaunch_resultopt_ecompliance === "N"
            ? styles.negativeOptions
            : ""
        const bHasObservation = !!levelLaunch?.eqpanltlaunch_cobservation
        const analyteLevel = oAnalyte?.anlt_levels?.find(
          (analyteLevel) => analyteLevel.elevel === level.level,
        )

        return (
          <td key={`run-${run}-launch-level-${level.level}`} disabled={!analyteLevel?.bavailable}>
            <Flex alignItems="flex-start" gap="2px" width="100%">
              {bIsQuantitativeAnalaite ? (
                <p>
                  {levelLaunch?.eqpanltlaunch_nvalue
                    ? Number(levelLaunch?.eqpanltlaunch_nvalue)
                        ?.toFixed(nDecimalPlaces)
                        ?.replace(".", ",")
                    : "-"}
                </p>
              ) : (
                <p className={cOptionsClass}>
                  {levelLaunch?.eqpanltlaunch_resultopt_cdescription || "N/A"}
                </p>
              )}

              <button
                type="button"
                title={intl.get("ciq.launch_observation.title")}
                className={`${styles.observatonButton} ${
                  bHasObservation ? styles.active : ""
                }`}
                disabled={!analyteLevel?.bavailable}
                onClick={() => handleOpenModalObservation(levelLaunch)}
              >
                <FileIcon />
              </button>
            </Flex>
          </td>
        )
      })}
      <td>
        <div className={styles.actions}>
          <button
            style={{
              // cursor: isOnlyView ? "not-allowed" : "pointer",
            }}
          >
            <CommunicationIcon
              onClick={() => {
                // if (isPermition) return
                openRunDetails()
              }}
              stroke={cCommunicationIconColor}
            />
          </button>
          <button
           style={{
               cursor: isPermition ? "not-allowed" : "pointer",
            }}
            onClick={() => {
              if (isPermition) return
              const oldValues = CONTROL_LEVELS.map((level) => {
                return run?.eqpanltrun_launches.find(
                  (launch) => launch.eqpanltlaunch_elevel === level.level,
                )
              })
                .filter((it) => it)
                .map((it) => ({
                  eqpanltlaunch_elevel: it.eqpanltlaunch_elevel,
                  eqpanltlaunch_nvalue: +it.eqpanltlaunch_nvalue,
                  eqpanltlaunch_resultopt_nid: it?.eqpanltlaunch_resultopt_nid || null,
                }))

              enableEditing(oldValues)
            }}
          >
            <EditIcon stroke="#6CB6E3" />
          </button>
          <button
            onClick={openRunDeleteModal}
          >
            <TrashIcon width={20} height={20} className={`${styles.deleteRunButton} ${!bCanDeleteRun ? styles.disabled : ''}`} />
          </button>
        </div>
      </td>
    </tr>
  )
}

const TableRowEditMode = ({ run, onDisabledEditMode, nDecimalPlaces }) => {
  const { setBUpdateJustityModalIsOpen, setOLaunchs, oAnalyte } = useTableFormLaunch()
  const [bModalInformation, setBInformation] = useState(false)
  const bIsQuantitativeAnalaite = oAnalyte?.anlt_type === "Quantitativo"

  const getQuantitativeValues = () => {
    return run?.eqpanltrun_launches?.reduce((acc, level) => {
      acc[`level${level.eqpanltlaunch_elevel}`] = level?.eqpanltlaunch_nvalue
      acc.eqpanltlaunch_nid = level.eqpanltlaunch_nid

      return acc
    }, {})
  }

  const getSemiQuantitativeAndQualitativeValues = () => {
    return run?.eqpanltrun_launches?.reduce((acc, level) => {
      acc[`result_option_level${level.eqpanltlaunch_elevel}`] = level.eqpanltlaunch_resultopt_nid,
      acc[`level${level.eqpanltlaunch_elevel}`] = true
      acc.eqpanltlaunch_nid = level.eqpanltlaunch_nid

      return acc
    }, {})
  }

  const { control, getValues, register } = useForm({
    defaultValues: bIsQuantitativeAnalaite
      ? getQuantitativeValues()
      : getSemiQuantitativeAndQualitativeValues(),
  })

  const openModal = () => {
    setOLaunchs({
      run: run,
      ...getValues(),
    })
    setBUpdateJustityModalIsOpen(true)
  }

  return (
    <>
      <tr>
        <td>{run?.eqpanltrun_number}</td>
        {CONTROL_LEVELS.map((level) => {
          const levelLaunch = run?.eqpanltrun_launches.find(
            (launch) => launch.eqpanltlaunch_elevel === level.level,
          )
          const analyteLevel = oAnalyte?.anlt_levels?.find(
            (analyteLevel) => analyteLevel.elevel === level.level,
          )

          return (
            <td key={`input-run-${run}-launch-level${level.level}`}>
              <div className={styles.editField}>
                {bIsQuantitativeAnalaite ? (
                  <InputNumber
                    nDecimalPlaces={nDecimalPlaces}
                    control={control}
                    name={`level${level.level}`}
                    value={levelLaunch?.eqpanltlaunch_nvalue}
                    disabled={!analyteLevel.bavailable}
                  />
                ) : (
                  <select
                    className={styles.select}
                    disabled={!analyteLevel.bavailable}
                    {...register(`result_option_level${level.level}`)}
                  >
                    {analyteLevel?.options.map((item) => {
                      if (levelLaunch?.eqpanltlaunch_resultopt_nid === null) {
                        return (
                          <>
                            <option value="" selected disabled hidden>
                              N/A
                            </option>
                            <option key={item.resultopt_nid} value={item.resultopt_nid}>
                              {item.resultopt_cdescription}
                            </option>
                          </>
                        )
                      } else {
                        return (
                          <option
                            key={item.resultopt_nid}
                            value={item.resultopt_nid}
                            selected={
                              item.resultopt_nid ===
                              levelLaunch?.eqpanltlaunch_resultopt_nid
                            }
                          >
                            {item.resultopt_cdescription}
                          </option>
                        )
                      }
                    })}
                  </select>
                )}
              </div>
            </td>
          )
        })}

        <td>
          <div className={styles.actions}>
            <button
              onClick={() => {
                // if (isChangedInput)
                setBInformation(true)
                // else
                // onDisabledEditMode()
              }}
            >
              <CloseIcon fill="#FF3541" width={20} height={20} />
            </button>
            <button onClick={openModal}>
              <CheckCircleBrokenIcon stroke="#1ECB4F" width={22} height={22} />
            </button>
          </div>
        </td>
      </tr>

      {bModalInformation && (
        <ModalInformation
          bgBtn="#1ECB4F"
          title={intl.get("ciq.releases")}
          description={intl.get("ciq.changes_not_save")}
          onCancel={() => setBInformation(false)}
          onClose={onDisabledEditMode}
        />
      )}
    </>
  )
}

const InputNumber = forwardRef((props, ref) => {
  return (
    <Controller
      ref={ref}
      {...props}
      render={({ field, ref }) => (
        <NumericFormat
          ref={ref}
          decimalScale={props.nDecimalPlaces}
          allowLeadingZeros
          fixedDecimalScale
          decimalSeparator=","
          autoComplete="off"
          placeholder={
            !field.disabled
              ? Number(0).toFixed(props.nDecimalPlaces).replace(".", ",")
              : "-"
          }
          className={styles.inputNumber}
          {...field}
        />
      )}
    />
  )
})
